type WorkflowNavigationDetails = Record<string, unknown>;

const storageKey = "motw.workflowNavigationDiagnostics";
const maxRecordCount = 200;

interface WorkflowNavigationRecord {
    timestamp: string;
    event: string;
    details?: WorkflowNavigationDetails;
    location: string;
    isOnline: boolean;
    visibilityState: string;
}

export function LogWorkflowNavigation(
    event: string,
    details?: WorkflowNavigationDetails
) {
    const record: WorkflowNavigationRecord = {
        timestamp: new Date().toISOString(),
        event,
        details,
        location: window.location.pathname,
        isOnline: window.navigator.onLine,
        visibilityState: document.visibilityState,
    };

    try {
        const records = GetWorkflowNavigationLogs();
        records.push(record);

        const recentRecords = records.slice(-maxRecordCount);
        localStorage.setItem(storageKey, JSON.stringify(recentRecords));
        ExposeWorkflowNavigationLogs(recentRecords);
    } catch (e) {
        console.log("[WorkflowNavigationDiagnostics] failed to store log", e);
    }
}

export function GetWorkflowNavigationLogs(): WorkflowNavigationRecord[] {
    try {
        return JSON.parse(localStorage.getItem(storageKey) || "[]");
    } catch (_e) {
        return [];
    }
}

export function GetWorkflowNavigationLogsText() {
    return JSON.stringify(GetWorkflowNavigationLogs(), null, 2);
}

export async function ReportWorkflowNavigationIssue(source: string) {
    LogWorkflowNavigation("WorkflowNavigationDiagnostics:report-issue", {
        source,
    });

    const fileName = GetWorkflowNavigationReportFileName();
    const reportText = GetWorkflowNavigationLogsText();

    const file = new File([reportText], fileName, {
        type: "application/json",
    });
    const navigatorWithShare = navigator as any;

    if (
        navigatorWithShare.canShare &&
        navigatorWithShare.share &&
        navigatorWithShare.canShare({ files: [file] })
    ) {
        await navigatorWithShare.share({
            files: [file],
            title: "MOTW workflow navigation diagnostics",
        });
        return;
    }

    DownloadDiagnosticsFile(reportText, fileName);
}

export function ClearWorkflowNavigationLogs() {
    localStorage.removeItem(storageKey);
    ExposeWorkflowNavigationLogs([]);
}

function ExposeWorkflowNavigationLogs(records: WorkflowNavigationRecord[]) {
    (window as any).tfaWorkflowNavigationLogs = records;
    (window as any).tfaClearWorkflowNavigationLogs =
        ClearWorkflowNavigationLogs;
}

function DownloadDiagnosticsFile(text: string, fileName: string) {
    const blob = new Blob([text], { type: "application/json;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

function GetWorkflowNavigationReportFileName() {
    const timestamp = new Date()
        .toISOString()
        .replace(/[:.]/g, "-");

    return `motw-workflow-navigation-${timestamp}.json`;
}
